module.exports = __webpack_public_path__ + "img/initialEle.c53c7419.svg";